<div class="table-responsive" [class.overflow-hidden]="incidentReportsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
        <tr [ngClass]="{'noSort': incidentReportsService.data.allIncidentReports.data.length < 2}">
            <th></th>
            <th (click)="orderBy('incidentReportNumber', $event)">ID#<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('incident', $event)">Incident<span class="footable-sort-indicator"></span></th>
            <th *ngIf="incidentReportsService.buildings.length > 1"
                (click)="orderBy('building.name', $event)">Building<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('incidentReportType', $event)">Type<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('suite', $event)">Unit<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('reportedArea', $event)">Report Area<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('reportedBy', $event)">Reported By<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('createdBy.fullName', $event)">Created By<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('incidentAt', $event)">Happened At<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">Created On<span class="footable-sort-indicator"></span></th>
        </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="incidentReportsService.data.allIncidentReports.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.incidentReportNumber}}</td>
                    <td>{{item.incident}}</td>
                    <td *ngIf="incidentReportsService.buildings.length > 1">{{item.buildingName}}</td>
                    <td>{{item.incidentReportType ? item.incidentReportType.name : item.incidentReportTypeOther}}</td>
                    <td>{{item.suiteNumber}}</td>
                    <td>{{item.reportedArea}}</td>
                    <td>{{item.reportedBy}}</td>
                    <td>{{item.createdBy.fullName}}</td>
                    <td>{{item.incidentAt | mccDate:true: true}}</td>
                    <td>{{item.createdAt | mccDate:false:true}}</td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of incidentReportsService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td>&nbsp;</td><td *ngIf="incidentReportsService.buildings.length > 1"></td>
                <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!incidentReportsService.data.allIncidentReports.total"
                          [isServiceUnavailable]="incidentReportsService.showServiceUnavailable"
                          [isLoading]="incidentReportsService.spinnerShow">
        You have no incident reports listed on the system<br>
        <span *ngIf="incidentReportsService.canEdit()">
            <a href="javascript://" (click)="incidentReportsService.isIncidentReportModalShow = true" class="mtv-primary-color clickable-text">add an incident report</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports-list/incident-reports-list.component.html